import { supabase } from '../../../shared/lib/supabaseClient';
import { logActivity } from '../../../shared/services/activityLogService';

// Every class secretary school-wide, one row per section at most, joined to their own student
// record (id, grade_level, section, ...). Lets the admin page show every section's secretary
// at once instead of one advisory at a time.
export async function getAllClassSecretaries() {
  const { data, error } = await supabase
    .from('class_secretaries')
    .select('student_id, students(id, lrn, firstname, lastname, grade_level, section)');
  if (error) throw error;
  return data.map((row) => row.students).filter(Boolean);
}

// Assigns `studentId` as their own section's class secretary, replacing `previousId` — that
// section's current secretary, if any — since a section has at most one at a time. Unlike the
// teacher-facing version in Advisory, this lets an admin do it for any section, not just their
// own advisory (see the "admins manage any section's secretary" RLS policy).
export async function setSectionSecretary(studentId, previousId, name) {
  if (previousId && previousId !== studentId) {
    const { error: deleteError } = await supabase.from('class_secretaries').delete().eq('student_id', previousId);
    if (deleteError) throw deleteError;
  }
  const { error } = await supabase.from('class_secretaries').upsert({ student_id: studentId });
  if (error) throw error;
  await logActivity('class_secretary_assigned', `Assigned ${name} as class secretary`);
}

export async function removeSectionSecretary(studentId, name) {
  const { error } = await supabase.from('class_secretaries').delete().eq('student_id', studentId);
  if (error) throw error;
  await logActivity('class_secretary_removed', `Removed ${name} as class secretary`);
}
